import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=0b15ac5d&"
import script from "./Forgot.vue?vue&type=script&lang=js&"
export * from "./Forgot.vue?vue&type=script&lang=js&"
import style0 from "./Forgot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b15ac5d')) {
      api.createRecord('0b15ac5d', component.options)
    } else {
      api.reload('0b15ac5d', component.options)
    }
    module.hot.accept("./Forgot.vue?vue&type=template&id=0b15ac5d&", function () {
      api.rerender('0b15ac5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Forgot.vue"
export default component.exports